// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/user_directory_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/user_directory_model.proto.
 */
export const file_bffuser_v1_user_directory_model: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL3VzZXJfZGlyZWN0b3J5X21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxIkMKBk1lbWJlchIaCgltZW1iZXJfaWQYASABKAlCB7pIBHICEAESHQoMZGlzcGxheV9uYW1lGAIgASgJQge6SARyAhABQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_buf_validate_validate]);

/**
 * Member is a single member of an organisation, projected from the internal
 * user directory (eauth). Mirrors internalapi.v1.Member; kept context-local
 * to bffuser to allow independent evolution.
 *
 * @generated from message bffuser.v1.Member
 */
export type Member = Message<"bffuser.v1.Member"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message bffuser.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_user_directory_model, 0);

